import { GetExtendAvailabilityRequest } from '@numa-group/checkout-api';
import { AxiosInstance } from 'axios';
import { addDays, formatISO } from 'date-fns';

import { IAuthService } from '@src/features/auth/services/i-auth-service';
import { ExtendStayRepository } from '@src/services/api/checkout/items/extend-stay.repository';

export class ExtendStayRepositoryMock implements ExtendStayRepository {
  constructor(
    private axiosInstance: AxiosInstance,
    private authService: IAuthService,
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getAvailabilityInfo(request: GetExtendAvailabilityRequest) {
    return {
      maxPersons: 4,
      maxExtendableDate: formatISO(addDays(new Date(), 100)),
    };
  }
}
